// extracted by mini-css-extract-plugin
module.exports = {"text":"text--1rsUZ","default":"default--Qnowa","active":"active--1Gjsb","card":"card--2FZVM"};